import { Component, Inject} from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { Data } from "@angular/router";
import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { GTMSagmentService } from "src/app/services/gtm-sagment.service";
import { ShareButtonModule } from "ngx-sharebuttons/button";

@Component({
    selector: 'app-desktop-share',
    templateUrl: './desktop-share.component.html',
    styleUrls: ['./desktop-share.component.scss'],
    standalone: true,
    imports: [ShareButtonModule],
})
export class DesktopShareComponent {
  public shareLink: string; // variable containing share link
  public referralMessage: string;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: Data,
    private GTMSegment: GTMSagmentService,
    private accountRepositoryService: AccountRepositoryService
  ) {
    try {
      this.shareLink = data?.shareLink;
      this.referralMessage = data?.mgm?.referral_message;
      this.GTMSegment.GTMPopupInitialization("DesktopShareComponent");
      this.accountRepositoryService.setShortUrl(this.shareLink);
    } catch (error) {
      throw new Error(`An error occurred: ${error}`);
    }
  }



}
